import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-dqf-outlet',
    templateUrl: './dqf-outlet.component.html',
    styleUrls: ['./dqf-outlet.component.scss'],
    standalone: true,
    imports: [RouterOutlet]
})
export class DqfOutletComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
